import { render, staticRenderFns } from "./stream8.vue?vue&type=template&id=c2355f80&"
import script from "./stream8.vue?vue&type=script&lang=js&"
export * from "./stream8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports